export const EMIRATES = [
  { key: 'abu_dhabi', ar: 'أبوظبي', en: 'Abu Dhabi' },
  { key: 'dubai', ar: 'دبي', en: 'Dubai' },
  { key: 'sharjah', ar: 'الشارقة', en: 'Sharjah' },
  { key: 'ajman', ar: 'عجمان', en: 'Ajman' },
  { key: 'umm_al_quwain', ar: 'أم القيوين', en: 'Umm Al Quwain' },
  { key: 'ras_al_khaimah', ar: 'رأس الخيمة', en: 'Ras Al Khaimah' },
  { key: 'fujairah', ar: 'الفجيرة', en: 'Fujairah' },
];

export const emptyCell = () => ({
  enabled: false, gov_fee: '', company_fee: '', duration_days: '', extra_office_fee_enabled: false, extra_office_fee: '', extra_offices: [],
});

export const emptyOfficeRow = () => ({ office_id: '', fee: '' });

/* Legacy cells had one fee without an office → one row that still needs an office chosen. */
export const normalizeOffices = (c) => {
  if (Array.isArray(c?.extra_offices) && c.extra_offices.length) return c.extra_offices.map((r) => ({ office_id: r?.office_id || '', fee: r?.fee ?? '' }));
  if (c?.extra_office_fee_enabled && Number(c?.extra_office_fee || 0) > 0) return [{ office_id: '', fee: c.extra_office_fee }];
  return [];
};

export const cellTotal = (c) => {
  if (!c) return 0;
  const extra = c.extra_office_fee_enabled ? normalizeOffices(c).reduce((s, r) => s + Number(r.fee || 0), 0) : 0;
  return Number(c.gov_fee || 0) + Number(c.company_fee || 0) + extra;
};

/* Normalise whatever the API returns into a full 7-key map (missing emirates = disabled). */
export const normalizePricing = (ep) => {
  const out = {};
  EMIRATES.forEach(({ key }) => {
    const c = (ep && ep[key]) || {};
    out[key] = { ...emptyCell(), ...c, enabled: Boolean(c.enabled), extra_offices: normalizeOffices(c) };
  });
  return out;
};

/* Card footer summary: enabled count + min–max total across enabled emirates. */
export const pricingSummary = (service, isAr) => {
  const ep = normalizePricing(service?.emirate_pricing);
  const enabled = EMIRATES.filter(({ key }) => ep[key].enabled);
  if (!enabled.length) return { count: 0, text: isAr ? 'لا توجد إمارات مفعّلة' : 'No emirates enabled' };
  const totals = enabled.map(({ key }) => cellTotal(ep[key]));
  const lo = Math.min(...totals); const hi = Math.max(...totals);
  const range = lo === hi ? lo.toLocaleString() : `${lo.toLocaleString()} - ${hi.toLocaleString()}`;
  return { count: enabled.length, text: `${range} ${isAr ? 'د.إ' : 'AED'}` };
};
